import { globalEventBus } from '@fiverr-private/futile';
import { logger } from '@fiverr-private/obs';
import { EventProps, EVENTS, GO_FLOATING_CHAT_TRIGGERS_READY, POLLING_ATTEMPTS, POLLING_DELAY } from '../constants';

const waitForListenerReady = () =>
    new Promise<void>((resolve, reject) => {
        const isReady = () => typeof window !== 'undefined' && window[GO_FLOATING_CHAT_TRIGGERS_READY];

        if (isReady()) {
            resolve();
            return;
        }

        let currentAttempt = 0;

        const interval = setInterval(() => {
            if (currentAttempt >= POLLING_ATTEMPTS) {
                clearInterval(interval);
                reject();
                return;
            }

            if (isReady()) {
                clearInterval(interval);
                resolve();
            }

            ++currentAttempt;
        }, POLLING_DELAY);
    });

export const openFloatingChat = async <T>(payload?: EventProps<T>) => {
    try {
        await waitForListenerReady();
        await globalEventBus.deferred(EVENTS.GO_OPEN_FLOATING_CHAT, { data: payload?.data });
    } catch (error) {
        logger.error('[Go Floating Chat Triggers] Failed to open floating chat', {
            error: error instanceof Error ? error.message : 'Unknown error',
        });
    }
};
